import { createRef, useContext } from "react";
import JSONSchemaForm from "@rjsf/core";
import useUpdate from "./useUpdate";
import { DetailsActionContext } from "./DetailsActionContext";
import {showSuccessMessage} from "@beeldit/core/helpers/messagesHelper";
import useGetByEntity from "@bloonde/billing/invoice-accounts/actions/details/useGetByEntity";
import InvoiceAccountForm from "@bloonde/billing/invoice-accounts/components/InvoiceAccountForm";
import useStoreDetail from "@bloonde/billing/invoice-accounts/actions/details/useStoreDetail";

function useDetailsAction(id: number, entityType: string, formDefaultValues: any = {}): any {

  const get = useGetByEntity();
  const getFunction = () => get(id, entityType, formDefaultValues);

  /**
   * Form store success function definition
   */

  const onSuccessUpdate = () => {
    showSuccessMessage("successfull_action");
    getFunction(); // We pass the function to refresh the table on success
  };

  const update = useUpdate();
  const updateFunction = () => update(onSuccessUpdate);

  const store = useStoreDetail();
  const storeFunction = () => store(onSuccessUpdate);

  /** Edition element definition */
  const { element } = useContext(DetailsActionContext);

  /**
   * Form Reference definition
   */
  const formRef = createRef<JSONSchemaForm>();  

  const onSubmitFunction = () => formRef.current?.formElement.current.requestSubmit() //We pass the function for the submit of the modal

  /**
   * Form configuration definition
   */
  const formConfig = {
    formRef: formRef, // We pass the ref to the form
    onSubmit: () => {
      element.id ? updateFunction() : storeFunction();
    },
    element: element, // We pass the element to the form in order to render it in the modal form
    context: DetailsActionContext,
    action: element.id ? 'edit' : 'create',
    className: "invoice-account-form",
    formDefaultValues: formDefaultValues
  };

  const actionTemplate = (
    <InvoiceAccountForm formConfig={formConfig} />
  );

  /** END EDIT FORM ACTION */

  return {
    element,
    getFunction,
    onSubmitFunction,
    actionTemplate,
  };
}

export default useDetailsAction;
